var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("增加")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.taskList, function (send, sendIndex) {
        return _c(
          "div",
          { key: sendIndex, staticStyle: { "margin-bottom": "15px" } },
          [
            send.contractList && send.contractList.length > 0
              ? _c(
                  "div",
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%", "font-size": "13px" },
                        attrs: {
                          data: send.contractList,
                          size: "small",
                          "header-cell-style": {
                            backgroundColor: "#e8eaed",
                            color: "#333",
                            fontWeight: "bold",
                          },
                          border: "",
                          "row-key": "id",
                          "default-expand-all": "",
                        },
                        on: { "row-click": _vm.handleRowClick },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            width: "120",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#F56C6C" },
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleCancel(row.row)
                                          },
                                        },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { type: "expand" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (contractScope) {
                                  return [
                                    contractScope.row.designSchemes &&
                                    contractScope.row.designSchemes.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "nested-table-wrapper",
                                            staticStyle: {
                                              padding: "10px 30px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-table",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  data: contractScope.row
                                                    .designSchemes,
                                                  size: "mini",
                                                  "header-cell-style": {
                                                    backgroundColor: "#e8eaed",
                                                    color: "#333",
                                                    fontWeight: "bold",
                                                  },
                                                  border: "",
                                                  "row-key": "id",
                                                  "default-expand-all": "",
                                                },
                                                on: {
                                                  "row-click":
                                                    _vm.handleRowClick,
                                                },
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "操作",
                                                    width: "100",
                                                    align: "center",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (
                                                          designScope
                                                        ) {
                                                          return [
                                                            _c(
                                                              "el-button",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#F56C6C",
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  size: "mini",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.handleCancel(
                                                                        designScope.row
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("取消")]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: { type: "expand" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (
                                                          designScope
                                                        ) {
                                                          return [
                                                            designScope.row
                                                              .orderSolutions &&
                                                            designScope.row
                                                              .orderSolutions
                                                              .length > 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "nested-table-wrapper",
                                                                    staticStyle:
                                                                      {
                                                                        padding:
                                                                          "10px 30px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-table",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100%",
                                                                          },
                                                                        attrs: {
                                                                          data: designScope
                                                                            .row
                                                                            .orderSolutions,
                                                                          size: "mini",
                                                                          "header-cell-style":
                                                                            {
                                                                              backgroundColor:
                                                                                "#e8eaed",
                                                                              color:
                                                                                "#333",
                                                                              fontWeight:
                                                                                "bold",
                                                                            },
                                                                          border:
                                                                            "",
                                                                          "row-key":
                                                                            "id",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-table-column",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                label:
                                                                                  "操作",
                                                                                width:
                                                                                  "100",
                                                                                align:
                                                                                  "center",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "default",
                                                                                    fn: function (
                                                                                      orderScope
                                                                                    ) {
                                                                                      return [
                                                                                        _c(
                                                                                          "el-button",
                                                                                          {
                                                                                            staticStyle:
                                                                                              {
                                                                                                color:
                                                                                                  "#F56C6C",
                                                                                              },
                                                                                            attrs:
                                                                                              {
                                                                                                type: "text",
                                                                                                size: "mini",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  $event.stopPropagation()
                                                                                                  return _vm.handleCancel(
                                                                                                    orderScope.row
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "取消"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                true
                                                                              ),
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-table-column",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                prop: "solutionName",
                                                                                label:
                                                                                  "订单方案名称",
                                                                                "min-width":
                                                                                  "140",
                                                                                align:
                                                                                  "center",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-table-column",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                prop: "packages",
                                                                                label:
                                                                                  "包件数",
                                                                                "min-width":
                                                                                  "80",
                                                                                align:
                                                                                  "center",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-table-column",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                label:
                                                                                  "面积(m²)",
                                                                                "min-width":
                                                                                  "100",
                                                                                align:
                                                                                  "center",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "default",
                                                                                    fn: function (
                                                                                      orderScope
                                                                                    ) {
                                                                                      return [
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                orderScope
                                                                                                  .row
                                                                                                  .area
                                                                                              ) +
                                                                                                "m²"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                true
                                                                              ),
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "text-align":
                                                                          "center",
                                                                        padding:
                                                                          "20px",
                                                                        color:
                                                                          "#909399",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "暂无订单方案信息"
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "productionOrder",
                                                    label: "销售单号",
                                                    "min-width": "140",
                                                    align: "center",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "总包数量",
                                                    "min-width": "90",
                                                    align: "center",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (
                                                          designScope
                                                        ) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getDesignSchemeTotalPackages(
                                                                    designScope.row
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                              padding: "20px",
                                              color: "#909399",
                                            },
                                          },
                                          [_vm._v("暂无设计方案信息")]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contractNo",
                            label: "合同号",
                            "min-width": "140",
                            align: "center",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contactPerson",
                            label: "客户",
                            "min-width": "100",
                            "show-overflow-tooltip": "",
                            align: "center",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contactNumber",
                            label: "收货电话",
                            width: "130",
                            align: "center",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contactAddress",
                            label: "收货地址",
                            "min-width": "180",
                            "show-overflow-tooltip": "",
                            align: "center",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      padding: "20px",
                      color: "#909399",
                    },
                  },
                  [_vm._v("暂无合同信息")]
                ),
          ]
        )
      }),
      _vm._v(" "),
      !_vm.taskList || _vm.taskList.length === 0
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                padding: "40px",
                color: "#909399",
              },
            },
            [_vm._v("\n    暂无任务信息\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addDialogVisible,
            title: "增加任务",
            width: "80%",
            top: "20px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
            opened: _vm.loadAddTableData,
            close: _vm.handleAddDialogClose,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.addTableLoading,
                  expression: "addTableLoading",
                },
              ],
              attrs: { "element-loading-text": "加载中..." },
            },
            [
              _c(
                "el-table",
                {
                  ref: "addContractTable",
                  staticStyle: { width: "100%", "font-size": "14px" },
                  attrs: {
                    data: _vm.addContractList,
                    "max-height": 600,
                    "header-cell-style": {
                      backgroundColor: "#e8eaed",
                      color: "#333",
                      fontWeight: "bold",
                    },
                    border: "",
                    "row-key": "contractId",
                  },
                  on: {
                    "selection-change": _vm.handleAddContractSelectionChange,
                    "row-click": _vm.handleAddContractRowClick,
                    "expand-change": _vm.handleAddContractExpandChange,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "50",
                      "reserve-selection": true,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { type: "expand" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.designSchemes &&
                            scope.row.designSchemes.length > 0
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-left": "20px" } },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        ref:
                                          "addDesignTable_" +
                                          scope.row.contractId,
                                        staticStyle: {
                                          width: "calc(100% - 20px)",
                                          "font-size": "13px",
                                        },
                                        attrs: {
                                          data: scope.row.designSchemes,
                                          size: "small",
                                          "header-cell-style": {
                                            backgroundColor: "#e8eaed",
                                            color: "#333",
                                            fontWeight: "bold",
                                          },
                                          border: "",
                                          "row-key": "id",
                                        },
                                        on: {
                                          "selection-change":
                                            _vm.handleAddDesignSelectionChange,
                                          "row-click":
                                            _vm.handleAddDesignRowClick,
                                          "expand-change":
                                            _vm.handleAddDesignExpandChange,
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            type: "selection",
                                            width: "50",
                                            "reserve-selection": true,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: { type: "expand" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (designScope) {
                                                  return [
                                                    designScope.row
                                                      .orderSolutions &&
                                                    designScope.row
                                                      .orderSolutions.length > 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "margin-left":
                                                                "20px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-table",
                                                              {
                                                                ref:
                                                                  "addSolutionTable_" +
                                                                  designScope
                                                                    .row.id,
                                                                staticStyle: {
                                                                  width: "100%",
                                                                  "font-size":
                                                                    "13px",
                                                                },
                                                                attrs: {
                                                                  data: designScope
                                                                    .row
                                                                    .orderSolutions,
                                                                  size: "small",
                                                                  "header-cell-style":
                                                                    {
                                                                      backgroundColor:
                                                                        "#e8eaed",
                                                                      color:
                                                                        "#333",
                                                                      fontWeight:
                                                                        "bold",
                                                                    },
                                                                  border: "",
                                                                  "row-key":
                                                                    "id",
                                                                },
                                                                on: {
                                                                  "selection-change":
                                                                    _vm.handleAddSolutionSelectionChange,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-table-column",
                                                                  {
                                                                    attrs: {
                                                                      type: "selection",
                                                                      width:
                                                                        "50",
                                                                      "reserve-selection": true,
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-table-column",
                                                                  {
                                                                    attrs: {
                                                                      prop: "solutionName",
                                                                      label:
                                                                        "方案名称",
                                                                      "min-width":
                                                                        "120",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-table-column",
                                                                  {
                                                                    attrs: {
                                                                      prop: "packages",
                                                                      label:
                                                                        "包数",
                                                                      "min-width":
                                                                        "80",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-table-column",
                                                                  {
                                                                    attrs: {
                                                                      prop: "area",
                                                                      label:
                                                                        "面积",
                                                                      "min-width":
                                                                        "80",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "default",
                                                                            fn: function (
                                                                              sRow
                                                                            ) {
                                                                              return [
                                                                                _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        sRow
                                                                                          .row
                                                                                          .area ||
                                                                                          0
                                                                                      ) +
                                                                                        " m²"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              color: "#909399",
                                                              "text-align":
                                                                "center",
                                                              padding: "20px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "暂无订单方案"
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "productionOrder",
                                            label: "销售单号",
                                            "min-width": "140",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "总包数量",
                                            "min-width": "90",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (dRow) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getDesignSchemeTotalPackages(
                                                            dRow.row
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      color: "#909399",
                                      "text-align": "center",
                                      padding: "20px",
                                    },
                                  },
                                  [_vm._v("暂无设计方案")]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "contractNumber",
                      label: "合同号",
                      "min-width": "160",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "custName",
                      label: "客户名称",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "custMobile",
                      label: "客户手机",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "custAddress",
                      label: "客户地址",
                      "min-width": "180",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmAdd } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }